// src/hook/VersionChecker.js
import { useEffect, useState } from 'react';

const CURRENT_VERSION = '1.9.0'; // Match with your deployed version

function useVersionChecker() {
    const [isUpdateAvailable, setIsUpdateAvailable] = useState(false);
  
    useEffect(() => {
      const interval = setInterval(async () => {
        try {
          console.log('Checking for version update...');
          const response = await fetch('/version.json', { cache: 'no-store' });
          if (!response.ok) {
            throw new Error('Version file not found');
          }
          const data = await response.json();
          console.log('Fetched version:', data.version);
          if (data.version !== CURRENT_VERSION) {
            console.log(`New version detected: ${data.version}`);
            setIsUpdateAvailable(true);
          }
        } catch (error) {
          console.error('Failed to check app version:', error);
        }
      }, 30000); // every 30 seconds
  
      return () => clearInterval(interval);
    }, []);
  
    return isUpdateAvailable;
  }
  

export default useVersionChecker;
